import styled from 'styled-components'
import {useContext} from "react";
import {DashboardContext} from "../../controlPanel";
import {useTranslation} from "react-i18next";
import {GLOBAL_ICON} from "../../../../interfaceGlobal";
import {Text} from "../../../../common/text";
import { Link } from 'react-router-dom'
import {fDateTimeCustom} from "../../../../util/formatTime";
import {useWindowSize} from "../../../../Component/ListMenu/listMenu";

export const ProductQuantityLow=()=>{
    const {t}= useTranslation()
    const [width]= useWindowSize()
    const {state} = useContext(DashboardContext)
    const {purchase_date, total_products} = state.productQuantity
    return(
        <StyleProductQuantityLow>
            <div className={'quantity-low__title'}>
                <div className={'quantity-low__label'}>
                    {GLOBAL_ICON.dashboardProductLow}
                    <Text fontSize={width === 1280 ? 13 : 16}>{t('product_quantity_low')}</Text>
                </div>
                <Link className={'quantity-low__label'} style={{gap: 4}} to={'/report/warehouse/quantity-low-rate'}>
                    <Text fontSize={width === 1280 ? 11 : 13} color={'#0052FF'}>{t('view_details')}</Text>
                    {GLOBAL_ICON.arrowLeft}
                </Link>
            </div>
            <div className={'quantity-low__content'}>
                <div style={{height: 34}}>
                    <Text fontSize={24} fontWeight={600}>{total_products || 0}</Text>&nbsp;
                    <Text>{t('product')}</Text>
                </div>
                <div>
                    <Text>{t('purchase_date_close_by')}</Text>&nbsp;
                    <Text fontWeight={600}>{!!purchase_date ? fDateTimeCustom(purchase_date) : '---'}</Text>
                </div>
            </div>
        </StyleProductQuantityLow>
    )
}
const StyleProductQuantityLow= styled.div`
  background: #ffffff;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 24px;
  .quantity-low{
    &__title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 38px;
    } 
    &__label{
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &__content{
      background: #F7F9FD;
      border-radius: 8px;
      padding: 12px;
    }
  }
`

